export default __webpack_public_path__ + "static/media/David.305d80fb.png";